
/**
 * Check if Flexbox Gap property is supported.
 * HACK: This is needed as there is no good way to detect support. This is because gap does work with display: grid, but not with flex.
 * Needed for Safari versions lower than 14.1.
 */
 (function checkFlexGap() {
  // create flex container with row-gap set
  const flex = document.createElement('div');
  flex.style.display = 'flex';
  flex.style.flexDirection = 'column';
  flex.style.rowGap = '1px';

  // create two, elements inside it
  flex.appendChild(document.createElement('div'));
  flex.appendChild(document.createElement('div'));

  // append to the DOM (needed to obtain scrollHeight)
  document.body.appendChild(flex);
  const isSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap
  flex.parentNode.removeChild(flex);

  document.documentElement.classList.add(!isSupported ? 'no-flex-gap' : 'supports-flex-gap');
}())



// WEBPACK FOOTER //
// ./scripts/custom/support.js